export const PROFILE_PHOTO_EVENT = "profile-photo-changed";

export const photoSource = (photo) => {
  if (!photo) return undefined;
  return ((photo.startsWith("data:")) ? photo : `data:image/png;base64,${photo}`);
};

export const getNameIcon = (name) => {
  const parts = (name || "").split(/[\s._-]+/).filter(Boolean);

  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0][0].toUpperCase();

  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
